import { CloseCircleOutlined } from "@ant-design/icons";
import { Empty, Modal } from "antd";
import RecipeAddOnsInputs from "./RecipeAddOnsInputs";
import useScrollLock from "../../../hooks/useScrollLock";

export default function RecipeFoodAddOnsModal({
  open,
  handleOk,
  setOpenModal,
  addOns = [],
  updateAddOns = () => {},
  // handleAddAddOns = () => {},
  // handleRemoveAddOns = () => {},
  handleSaveAddOn = () => {},
  handleCancelAddOn = () => {},
  setSelectedAddOns,
}) {

  function handleCancel() {
    setOpenModal(false);
  }

  // Lock scroll when modal is open
  useScrollLock(open);

  return (
    <div>
      <Modal
        closeIcon={<CloseCircleOutlined />}
        wrapClassName={"recipe-addons-modal"}
        open={open}
        title={<span className="text-black">Food Add-Ons</span>}
        onOk={handleOk}
        closable={true}
        onCancel={handleCancel}
        footer={[
          <div key={crypto.randomUUID()}>
            {addOns.length > 0 && (
              <div className="flex items-center space-x-[10px]">
                <button
                  className="w-[100px] h-[42px] text-sm leading-[16px] text-white bg-[#FA6060] rounded-[5px]"
                  onClick={handleCancelAddOn}
                >
                  Cancel
                </button>
                <button
                  className="w-[100px] h-[42px] text-sm leading-[16px] text-white bg-[#2EC114] rounded-[5px]"
                  onClick={handleSaveAddOn}
                >
                  Save
                </button>
              </div>
            )}
          </div>,
        ]}
      >
        <div className="custom-modal-container">
          <div>
            {Boolean(addOns) && addOns.length > 0 ? (
              addOns.map((addOn, idx) => (
                <div className="w-full flex items-center gap-x-[60px] mb-3" key={addOn.addOnId}>
                  <RecipeAddOnsInputs
                    addOnId={addOn.addOnId}
                    currentAddOn={addOn}
                    updateAddOns={updateAddOns}
                    setSelectedAddOns={setSelectedAddOns}
                  />
                  {/* {idx === addOns.length - 1 ? (
                  <button className="" onClick={handleAddAddOns}>
                    <Image src="/images/icons/add_one.svg" preview={false} />
                  </button>
                ) : (
                  <button className="" onClick={() => handleRemoveAddOns(addOn.id)}>
                    <Image src="/images/icons/remove_one.svg" preview={false} />
                  </button>
                )} */}
                </div>
              ))
            ) : (
              <Empty description={false}>
                <div>
                  <p className="font-p_regular font-medium text-gray-500">
                    No <span className="text-red-500">add-ons</span> are available at this moment. <br />Please add your <span className="text-[#2EC114]">add-ons</span> recipe!
                  </p>
                </div>
              </Empty>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}
